import { InjectionToken, Provider } from '@angular/core';
import { IAgentCard } from '@dataclouder/ngx-agent-cards';
import { MasterStateService, provideMasterState } from '@dataclouder/ngx-knowledge';
import { ILesson } from '@dataclouder/ngx-lessons';

import { IWordBase } from '../lexicore/lexicore.classes';

export const LESSONS_MASTER_STATE = new InjectionToken<MasterStateService<ILesson>>('lessons.state.service');
export const AGENT_CARDS_STATE_SERVICE = new InjectionToken<MasterStateService<IAgentCard>>('agent-cards.state.service');
export const WORDS_MASTER_STATE = new InjectionToken<MasterStateService<IWordBase>>('words.state.service');

// I instanciate here, but... is changing after get user language.
export function provideKnowledge(): Provider[] {
  return [
    provideMasterState<ILesson>(LESSONS_MASTER_STATE, {
      pathTable: null,
      sourceCoreEndPoint: 'api/lessons/query',
      userStateEndPoint: 'api/knowledge/learning-experience',
    }),
    provideMasterState<IAgentCard>(AGENT_CARDS_STATE_SERVICE, {
      pathTable: null,
      sourceCoreEndPoint: 'api/agent-cards/query',
      userStateEndPoint: 'api/knowledge/learning-experience',
    }),
    provideMasterState<IWordBase>(WORDS_MASTER_STATE, {
      pathTable: null, // needs to be instantiated on runtime after get user language.
      sourceCoreEndPoint: 'api/words/query',
      userStateEndPoint: 'api/knowledge/knowledge-state', // use a method to concat api/knowledge/knowledge-state/{pathTable}
    }),
  ];
}
